<div edsFlexbox alignItems="center">
  <div>
    <p class="small spacing--xs">
      <ng-container *ngIf="headerLabelKey">
        {{ headerLabelKey | translate }}
        <eds-footnote
          *ngIf="footnotePlacement"
          [placement]="footnotePlacement"
        ></eds-footnote>
      </ng-container>
      <ng-container *ngIf="!headerLabelKey"> &nbsp; </ng-container>
    </p>
    <p class="small text-grey1 spacing--none" *ngIf="asOfDateText">
      {{ "pds.PERF_AS_OF_DATE" | translate }} {{ asOfDateText }}
    </p>
    <p
      class="small text-grey1 spacing--none"
      *ngIf="asOfDateText && showAsOfPutnamLabel"
    >
      {{ "products.asOfExcept" | translate }}
    </p>
  </div>
</div>
